// This instance has been reachable under several domains over time
// (pieville.local in development, plus pieville.net/.org/.com); showing
// any of them on every post/profile is just noise, so treat them all as
// "local" for display purposes regardless of which one is configured now.
const HIDDEN_DOMAIN_RE = /^pieville\.(?:local|net|org|com)$/i;

export function isHiddenDomain(domain: string | undefined | null): boolean {
  return !!domain && HIDDEN_DOMAIN_RE.test(domain);
}
